import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { ExportJobStatus } from "@/types/data-export";

type BadgeVariant = React.ComponentProps<typeof Badge>["variant"];

const STATUS_VARIANT: Record<ExportJobStatus, BadgeVariant> = {
  PENDING: "new_secondary",
  RUNNING: "status_in_progress",
  COMPLETED: "status_done",
  FAILED: "new_destructive",
};

interface ExportStatusBadgeProps {
  status: ExportJobStatus;
  className?: string;
}

export const ExportStatusBadge: React.FC<ExportStatusBadgeProps> = ({
  status,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Badge variant={STATUS_VARIANT[status]} className={className}>
      {t(`dataExport.status.${status}`)}
    </Badge>
  );
};
